module.exports = __webpack_public_path__ + "static/img/watting.78ed1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/watting.png
// module id = Swi7
// module chunks = 150